/// <amd-module name="Wit/Common/BacklogContent/FilterHeader" />
import * as React from "react";
import { format } from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { ConditionalChildren } from "VSSUI/ConditionalChildren";
import { CustomHeader } from "VSSUI/Header";
import { Link } from "VSSUI/Link";
import { Observer } from "VSSUI/Observer";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import * as Resources from "Wit/Common/BacklogContent/Resources";
import { ICommonBacklogContentService } from "Wit/Common/BacklogContentService/ICommonBacklogContentService";

interface IFilterHeaderProps {
    pageContext: IVssPageContext;
    onFilterMoreItems: (toPageCount: number) => void;
    unPagedItemCount: number;
    totalItemCount: number;
}

export function FilterHeader(props: IFilterHeaderProps) {
    const { pageContext, onFilterMoreItems, unPagedItemCount, totalItemCount } = props;

    const backlogContentService = pageContext.getService<ICommonBacklogContentService>("ICommonBacklogContentService");
    const itemsToPage = unPagedItemCount > 1000 ? 1000 : unPagedItemCount;
    return (
        <ConditionalChildren renderChildren={unPagedItemCount > 0}>
            <CustomHeader className="agile-filter-bar-header">
                <Observer showLoadingSpinner={backlogContentService.getIsLoadingNextBatchObservable()}>
                    {(observerProps: { showLoadingSpinner: boolean }) => {
                        return observerProps.showLoadingSpinner ? (
                            renderLoadingInProgressHeader()
                        ) : (
                            <>
                                <div className="flex-column justify-center flex-self-center margin-right-4">
                                    <span className="font-size-m">
                                        {format(Resources.FilteringSomeItems, totalItemCount - unPagedItemCount, totalItemCount)}
                                    </span>
                                </div>
                                <Link onClick={() => onFilterMoreItems(itemsToPage)}>{format(Resources.FilterNextItems, itemsToPage)}</Link>
                            </>
                        );
                    }}
                </Observer>
            </CustomHeader>
        </ConditionalChildren>
    );
}

function renderLoadingInProgressHeader() {
    return (
        <>
            <div className="flex-column justify-center flex-self-center margin-right-4">
                <span className="font-size-m">{Resources.Loading}</span>
            </div>
            <Spinner className="margin-left-4" size={SpinnerSize.medium} />
        </>
    );
}
